import moment, { Moment } from 'moment';

export const FORMAT_STRING = 'MM/DD/YYYY';
// max and min are these dates because these are the default values in the KeyboardDatePicker documentation
export const DEFAULT_MAX_DATE = moment('2100-01-01');
export const DEFAULT_MIN_DATE = moment('1900-01-01');

export const isValid = (date: Moment) => {
  if (!date.isValid()) {
    return false;
  }

  return date > DEFAULT_MIN_DATE && date < DEFAULT_MAX_DATE;
};

export const isHireDatePast = (application: FullApplicant) =>
  application.hireStartDateTime && moment(application.hireStartDateTime).isSameOrBefore(moment());
